/* eslint-disable no-console */
//import * as Sentry from '@sentry/browser';
import { APP_CRASH } from '../actions/rootAction';

export const crashReporter = store => next => action => {
  try {
    return next(action);
  } catch (err) {
    store.dispatch({
      type: APP_CRASH,
      payload: err
    });
    console.error('Redux store caught an exception!', err);
    //Sentry.captureException(err);
  }
};
